import { NxButtonModule } from '@allianz/ng-aquila/button';
import { NxContextMenuModule } from '@allianz/ng-aquila/context-menu';
import { NxHeaderModule } from '@allianz/ng-aquila/header';
import { NxIconModule } from '@allianz/ng-aquila/icon';
import { NxDialogService } from '@allianz/ng-aquila/modal';
import { NxViewportService } from '@allianz/ng-aquila/utils';
import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { TranslateModule } from '@ngx-translate/core';
import { debounceTime, map, startWith } from 'rxjs';

import { environment } from '../../../environments/environment';
import { ApiService } from '../../../shared/services/api.service';
import { MobileMenuComponent } from './mobile-menu/mobile-menu.component';
import { staticGlobtroterPaths } from './static-globtroter-paths';

export const mobileBreakpoint = 1350;
export const debounceTimeViewportChange = 100;
@Component({
  standalone: true,
  imports: [
    AsyncPipe,
    TranslateModule,
    NxButtonModule,
    NxContextMenuModule,
    NxHeaderModule,
    NxIconModule,
  ],
  selector: 'app-header',
  templateUrl: './app-header.component.html',
  styleUrls: ['./app-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppHeaderComponent {
  private viewportService = inject(NxViewportService);
  private dialogService = inject(NxDialogService);
  private apiService = inject(ApiService);

  readonly staticGlobtroterPaths = staticGlobtroterPaths;

  globtroterMenuConfig = toSignal(this.apiService.getGlobtroterMenu());
  globtroterUser = toSignal(this.apiService.getGlobtroterUser());
  globtroterConfig = toSignal(this.apiService.getGlobtroterConfig());
  globtroterApp = environment.globtroterApp;
  isMobileView$ = this.viewportService.viewportChange$.pipe(
    startWith(window.innerWidth),
    debounceTime(debounceTimeViewportChange),
    map((width) => width < mobileBreakpoint),
  );

  openModal() {
    this.dialogService.open(MobileMenuComponent, { showCloseIcon: true, fullscreen: true });
  }
}
